import { useState, useEffect } from "react";
import { buscarCotasDisponiveis } from "../../../services/buscarCotasDisponiveisService";

export const useBuscarCotasDisponiveis = () => {
  const [cotas, setCotas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);

    const data = await buscarCotasDisponiveis();

    const cotasFormatadas = await Promise.all(
      data.map(async (item: any) => ({
        id: item.id || "",
        proprietario:
          item.UsuarioTable.nome + " " + item.UsuarioTable.sobrenome,
        empreendimento: item.CotaTable.AptoTable.EmpreendimentoTable.nome,
        numeroCota: item.CotaTable.numeroCota,
      }))
    );

    setCotas(cotasFormatadas);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  return { cotas, isLoading, buscar };
};
